const services = [
  {
    icon: 'ri-tools-line',
    title: 'Orijinal ve Muadil Yedek Parça Temini',
    desc: 'Farklı marka ve model iş makinelerine uygun, yüksek kalite standartlarına sahip orijinal ve muadil yedek parçaları hızlı ve güvenilir şekilde temin ediyoruz.',
    num: '01',
  },
  {
    icon: 'ri-truck-line',
    title: 'Hızlı Tedarik ve Lojistik',
    desc: 'Zamanın değerini biliyoruz. Güçlü tedarik ağımız sayesinde ihtiyaç duyulan parçaları en kısa sürede müşterilerimize ulaştırıyoruz.',
    num: '02',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Teknik Destek ve Danışmanlık',
    desc: 'Alanında deneyimli ekibimizle, doğru parça seçimi ve kullanım süreçlerinde profesyonel destek sağlıyoruz.',
    num: '03',
  },
  {
    icon: 'ri-apps-2-line',
    title: 'Geniş Ürün Yelpazesi',
    desc: 'Motor parçalarından yürüyüş aksamına, hidrolik sistemlerden filtre gruplarına kadar iş makineleri için kapsamlı çözümler sunuyoruz.',
    num: '04',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Güvenilir Hizmet Anlayışı',
    desc: 'Kalite, dürüstlük ve sürdürülebilir iş ortaklığı ilkeleriyle müşterilerimize uzun vadeli çözümler sunmayı hedefliyoruz.',
    num: '05',
  },
];

export default function Services() {
  return (
    <section id="hizmetler" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-16 items-end">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-px bg-orange-500"></div>
              <span className="text-orange-500 text-xs font-bold tracking-[0.3em] uppercase">Hizmetlerimiz</span>
            </div>
            <h2 className="text-4xl md:text-6xl font-black text-gray-900 leading-none">
              GÜVENİLİR,
              <br />
              HIZLI VE
              <br />
              <span className="text-orange-500">KALİTELİ.</span>
            </h2>
          </div>
          <p className="text-gray-500 text-base leading-relaxed">
            İlke İş Makinaları olarak, iş makinesi sektöründe ihtiyaç duyulan yedek parça temini ve
            teknik destek alanlarında güvenilir, hızlı ve kaliteli çözümler sunmaktayız.
          </p>
        </div>

        {/* Services List */}
        <div className="space-y-px">
          {services.map((service) => (
            <div
              key={service.title}
              className="group flex flex-col md:flex-row items-start md:items-center gap-6 bg-gray-50 hover:bg-orange-50/50 p-8 transition-all duration-300 cursor-default relative overflow-hidden border border-gray-100"
            >
              {/* Left accent */}
              <div className="absolute left-0 top-0 bottom-0 w-0 group-hover:w-1 bg-orange-500 transition-all duration-300"></div>

              {/* Number */}
              <div className="text-orange-500/20 font-black text-5xl leading-none select-none w-16 flex-shrink-0 group-hover:text-orange-500/40 transition-colors duration-300">
                {service.num}
              </div>

              {/* Icon */}
              <div className="w-12 h-12 flex items-center justify-center border border-gray-200 group-hover:border-orange-500/40 rounded-sm flex-shrink-0 transition-colors duration-300">
                <i className={`${service.icon} text-xl text-gray-400 group-hover:text-orange-500 transition-colors duration-300`}></i>
              </div>

              {/* Content */}
              <div className="flex-1">
                <h3 className="font-black text-gray-900 text-lg mb-2 uppercase tracking-wide group-hover:text-orange-500 transition-colors duration-300">
                  {service.title}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed group-hover:text-gray-600 transition-colors duration-300">
                  {service.desc}
                </p>
              </div>

              {/* Arrow */}
              <div className="w-8 h-8 flex items-center justify-center text-gray-300 group-hover:text-orange-500 transition-colors duration-300 flex-shrink-0">
                <i className="ri-arrow-right-line text-xl"></i>
              </div>
            </div>
          ))}
        </div>

        {/* Process Steps */}
        <div className="mt-20">
          <div className="flex items-center gap-3 mb-12">
            <div className="w-8 h-px bg-orange-500"></div>
            <span className="text-orange-500 text-xs font-bold tracking-[0.3em] uppercase">Nasıl Çalışıyoruz?</span>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-px bg-gray-200">
            {[
              { step: '01', title: 'İletişime Geçin', desc: 'Telefon, e-posta veya form ile bize ulaşın.' },
              { step: '02', title: 'Parça Tespiti', desc: 'Uzmanlarımız ihtiyacınızı analiz eder.' },
              { step: '03', title: 'Teklif & Onay', desc: 'Fiyat teklifi alın, onaylayın.' },
              { step: '04', title: 'Hızlı Teslimat', desc: 'Parçanız en kısa sürede kapınızda.' },
            ].map((step) => (
              <div key={step.step} className="bg-white p-8 flex flex-col">
                <div className="text-orange-500 font-black text-4xl mb-4 leading-none">{step.step}</div>
                <div className="w-8 h-px bg-orange-500/30 mb-4"></div>
                <h4 className="font-black text-gray-900 text-sm uppercase tracking-wider mb-2">{step.title}</h4>
                <p className="text-gray-400 text-xs leading-relaxed">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
